/*
 All fetch functions here accept a callback. The callback will more than likely
 end up being a setState call in the component it is called from.
 */

import UpdoxApi from './updoxapi';

const headers = { 'Content-Type': 'application/json' };

/*
 @JsonProperty("email")
 private String email;
 */
const forgot = (email, successCallback, errorCallback) => {
  return UpdoxApi.postApi(
    'api/public/forgot-username',
    headers,
    JSON.stringify(email),
    successCallback,
    errorCallback,
  );
};

const UsernameApi = { forgot };

export default UsernameApi;



// WEBPACK FOOTER //
// ./src/apis/username.js